import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-attachments-section",
  templateUrl: "./app-attachments-section.component.html",
  styleUrls: ["./app-attachments-section.component.scss"],
})
export class AttachmentsSectionComponent {
  @Input() editFormMode = false;
  @Input() files: any[] = [];
  @Input() filesCopy: any[] = [];
  //Emit these as outputs so the parent component can handle the logic
  @Output() fileSelected = new EventEmitter<Event>();
  @Output() fileDropped = new EventEmitter<DragEvent>();
  @Output() fileDragOver = new EventEmitter<DragEvent>();
  @Output() downloadFile = new EventEmitter<number>();
  @Output() deleteFile = new EventEmitter<number>();

  onFileSelected(event: Event) {
    this.fileSelected.emit(event);
  }
  onDrop(event: DragEvent) {
    this.fileDropped.emit(event);
  }
  onDragOver(event: DragEvent) {
    this.fileDragOver.emit(event);
  }
  onDownloadFile(index: number) {
    this.downloadFile.emit(index);
  }
  onDeleteFile(index: number) {
    this.deleteFile.emit(index);
  }
}
